var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              (_vm.currentBetSlipState < 1 ||
                (_vm.betTypeStakes &&
                  _vm.betTypeStakes[_vm.eventId] &&
                  _vm.allowedBetTypesAndReturn &&
                  _vm.allowedBetTypesAndReturn.Price)) &&
              !_vm.isAllSelectionsNotEliglible,
            expression:
              "(currentBetSlipState<1 || (betTypeStakes && betTypeStakes[eventId] && allowedBetTypesAndReturn && allowedBetTypesAndReturn.Price)) && !isAllSelectionsNotEliglible"
          }
        ],
        staticClass: "SGP",
        class: [_vm.sgmPriceType]
      },
      [
        _c("h2", { staticClass: "header-PARLAY" }, [
          _vm.sgmPriceType !== "CP" ||
          (_vm.sgmPriceType === "CP" && _vm.showBadgeForMMsgp)
            ? _c("span", { class: "sgp-" + _vm.sgmPriceType + "-tag" })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("BetSlip.tab.title.SGP")))]),
          _vm._v(" "),
          _vm.sgpMarkAsNew &&
          (_vm.sgmPriceType !== "CP" ||
            (_vm.sgmPriceType === "CP" && _vm.showBadgeForMMsgp))
            ? _c("span", { staticClass: "new-indicator" }, [
                _vm._v(_vm._s(_vm.$t("BetSlip.tab.title.SGP.new")))
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.allowedBetTypes.length
          ? _c(
              "div",
              _vm._l(_vm.allowedBetTypes, function(bt) {
                return _c(
                  "div",
                  [
                    _c("bet-type-parlay", {
                      attrs: {
                        tab: _vm.tab,
                        bt: bt,
                        parlayTeamsNo: {
                          valid: _vm.combinableBetslipSelectionIds.length,
                          invalid:
                            _vm.notCombinableBetslipSelectionIds.length ||
                            _vm.notEligibleBetslipSelectionIds.length
                        },
                        sgmBetStatus: _vm.allowedBetTypesAndReturn.Status,
                        allowedBetTypesAndReturns: _vm.allowedBetTypesAndReturn,
                        gettingABTnR: _vm.gettingABTnR,
                        currentBetSlipState: _vm.currentBetSlipState,
                        isSGM: _vm.isSGM,
                        sgmPath: "XP.PerEvent",
                        idfosporttype: _vm.idfosporttype,
                        sgmSelectionsMap: {
                          validSGMselections: _vm.validSGMselections,
                          hasInvalidSGMselections: _vm.hasInvalidSGMselections
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.combinableBetslipSelectionIds.length ||
        _vm.notCombinableBetslipSelectionIds.length ||
        _vm.notEligibleBetslipSelectionIds.length
          ? _c(
              "div",
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !(
                          !_vm.expanded &&
                          (_vm.notCombinableBetslipSelectionIds.length ||
                            !_vm.allowedBetTypes.length)
                        ),
                        expression:
                          "!(!expanded && (notCombinableBetslipSelectionIds.length || !allowedBetTypes.length))"
                      }
                    ],
                    staticClass: "selections-heading"
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("BetSlip.tab.SGM.heading.SGP.selections"))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.combinableBetslipSelectionIds, function(
                  selectionId,
                  index
                ) {
                  return _c("sgm-selection", {
                    key: selectionId,
                    class: [
                      "SGM-STATUS-" + _vm.legStatus(selectionId),
                      "SGM-selection-" + (index + 1),
                      {
                        hidden:
                          !_vm.expanded &&
                          (index > _vm.hideBreakpoint ||
                            _vm.notCombinableBetslipSelectionIds.length ||
                            !_vm.allowedBetTypes.length),
                        "hidden-breakpoint":
                          !_vm.expanded &&
                          index == _vm.hideBreakpoint &&
                          _vm.combinableBetslipSelectionIds.length +
                            _vm.notCombinableBetslipSelectionIds.length >
                            _vm.showMoreIfNo
                      }
                    ],
                    attrs: {
                      id: selectionId,
                      isSGM: _vm.isSGM,
                      tab: _vm.tab,
                      currentBetSlipState: _vm.currentBetSlipState,
                      allowedMultiSingles: false,
                      allowedBetTypesAndReturns: {},
                      sgmPriceType: _vm.sgmPriceType
                    },
                    on: { removeSelection: _vm.removeSelection }
                  })
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.currentBetSlipState < 1 &&
                          _vm.notCombinableBetslipSelectionIds.length &&
                          !(!_vm.expanded && !_vm.allowedBetTypes.length),
                        expression:
                          "currentBetSlipState<1 && notCombinableBetslipSelectionIds.length && !(!expanded && !allowedBetTypes.length)"
                      }
                    ],
                    staticClass: "error-msg not-combinable",
                    class: {
                      top:
                        !_vm.combinableBetslipSelectionIds.length ||
                        !_vm.expanded
                    }
                  },
                  [
                    _c("v-icon", [_vm._v("info_outline")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "BetSlip.tab.SGM.info." +
                                (_vm.validSGMselections ? "SOME." : "") +
                                "NOT_COMBINABLE" +
                                (_vm.expanded ? ".expanded" : "")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.sgpShowProviderDetailedError &&
                      _vm.allowedBetTypesAndReturn &&
                      _vm.allowedBetTypesAndReturn.ErrorMessage
                        ? _c("div", { staticClass: "SGM-status-error" }, [
                            _vm._v(
                              _vm._s(_vm.allowedBetTypesAndReturn.ErrorMessage)
                            )
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.notCombinableBetslipSelectionIds, function(
                  selectionId,
                  index
                ) {
                  return _c("sgm-selection", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentBetSlipState < 1,
                        expression: "currentBetSlipState<1"
                      }
                    ],
                    key: "Not-Combinable-" + selectionId,
                    class: [
                      "SGM-STATUS-" + _vm.legStatus(selectionId),
                      "SGM-selection-" +
                        (index + _vm.combinableBetslipSelectionIds.length + 1),
                      {
                        hidden:
                          !_vm.expanded &&
                          (index + _vm.combinableBetslipSelectionIds.length >
                            _vm.hideBreakpoint ||
                            _vm.notCombinableBetslipSelectionIds.length),
                        "hidden-breakpoint":
                          !_vm.expanded &&
                          index + _vm.combinableBetslipSelectionIds.length ==
                            _vm.hideBreakpoint &&
                          _vm.combinableBetslipSelectionIds.length +
                            _vm.notCombinableBetslipSelectionIds.length >
                            _vm.showMoreIfNo
                      }
                    ],
                    attrs: {
                      id: selectionId,
                      isSGM: _vm.isSGM,
                      tab: _vm.tab,
                      currentBetSlipState: _vm.currentBetSlipState,
                      allowedMultiSingles: false,
                      allowedBetTypesAndReturns: {},
                      sgmPriceType: _vm.sgmPriceType
                    },
                    on: { removeSelection: _vm.removeSelection }
                  })
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.currentBetSlipState < 1 &&
                          _vm.notEligibleBetslipSelectionIds.length &&
                          (_vm.expanded ||
                            (!_vm.expanded &&
                              !_vm.notCombinableBetslipSelectionIds.length)),
                        expression:
                          "currentBetSlipState<1 && notEligibleBetslipSelectionIds.length && (expanded || (!expanded && !notCombinableBetslipSelectionIds.length))"
                      }
                    ],
                    staticClass: "error-msg not-combinable not-eligible",
                    class: {
                      top:
                        !_vm.notEligibleBetslipSelectionIds.length ||
                        !_vm.expanded
                    }
                  },
                  [
                    _c("v-icon", [_vm._v("info")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BetSlip.tab.SGM.info." +
                              (_vm.validSGMselections ? "SOME." : "") +
                              "NOT_ELIGIBLE" +
                              (_vm.expanded ? ".expanded" : ""),
                            {
                              n: _vm.notEligibleBetslipSelectionIds.length,
                              s:
                                _vm.notEligibleBetslipSelectionIds.length > 1
                                  ? "s"
                                  : ""
                            }
                          )
                        ) + "\n          "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.notEligibleBetslipSelectionIds, function(
                  selectionId,
                  index
                ) {
                  return _c("sgm-selection", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentBetSlipState < 1,
                        expression: "currentBetSlipState<1"
                      }
                    ],
                    key: "Not-Combinable-" + selectionId,
                    class: [
                      "SGM-STATUS-" + _vm.legStatus(selectionId),
                      "SGM-selection-" +
                        (index +
                          _vm.combinableBetslipSelectionIds.length +
                          _vm.notCombinableBetslipSelectionIds.length +
                          1),
                      {
                        hidden:
                          !_vm.expanded &&
                          (index +
                            _vm.combinableBetslipSelectionIds.length +
                            _vm.notCombinableBetslipSelectionIds.length >
                            _vm.hideBreakpoint ||
                            _vm.notEligibleBetslipSelectionIds.length),
                        "hidden-breakpoint":
                          !_vm.expanded &&
                          index +
                            _vm.combinableBetslipSelectionIds.length +
                            _vm.notCombinableBetslipSelectionIds.length ==
                            _vm.hideBreakpoint &&
                          _vm.combinableBetslipSelectionIds.length +
                            _vm.notCombinableBetslipSelectionIds.length +
                            _vm.notEligibleBetslipSelectionIds.length >
                            _vm.showMoreIfNo
                      }
                    ],
                    attrs: {
                      id: selectionId,
                      isSGM: _vm.isSGM,
                      tab: _vm.tab,
                      currentBetSlipState: _vm.currentBetSlipState,
                      allowedMultiSingles: false,
                      allowedBetTypesAndReturns: {},
                      sgmPriceType: _vm.sgmPriceType
                    },
                    on: { removeSelection: _vm.removeSelection }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentBetSlipState < 1 &&
        (_vm.notCombinableBetslipSelectionIds.length ||
          _vm.notEligibleBetslipSelectionIds.length ||
          _vm.combinableBetslipSelectionIds.length > _vm.showMoreIfNo)
          ? _c(
              "a",
              {
                staticClass: "toggleExpanded",
                on: {
                  click: function($event) {
                    return _vm.toggleExpanded()
                  }
                }
              },
              [
                _vm.expanded
                  ? _c("span", { staticClass: "btn-expanded less" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("BetSlip.tab.SGM.show.less")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.expanded
                  ? _c("span", { staticClass: "btn-expanded more" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("BetSlip.tab.SGM.show.more")))
                      ])
                    ])
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbc795f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbc795f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/SGM/SGP.vue
// module id = null
// module chunks = 